<script setup>
import ShowScheduleTile from '@components/show-schedule-tile'

defineProps({
    resources: {
        type: Array,
        default: () => [],
    },
    error: {
        type: [Object, Boolean],
        default: false,
    },
})
</script>

<template>
    <div class="show-schedule-block">
        <ShowScheduleTile
            v-for="resource in resources"
            :key="`show-schedule-item-${resource.air_start + resource.id || resource.id}`"
            :schedule-item="resource"
            artwork
        />
        <BaseEmptyList
            v-if="resources.length === 0 && error"
            :error="error"
        />
    </div>
</template>

<style lang="scss" scoped>
@use 'sass:math';
@use '@design' as *;

.show-schedule-block {
    min-height: 14rem;
    padding-bottom: math.div($s-h, 2);
}
</style>
